<template>
  <div class="auth-process-container">
    <div class="auth-process">
      <q-card bordered flat class="auth-process-card">
        <img :src="require('../assets/fleetvaluationsystem.png')" />
        <div
          style="display:flex;align-items:center;justify-content:center;text-align:center;margin:10px;font-size:14px;color:#666;font-weight:bold"
          v-text="message"
        />
        <div class="other-things">
          <router-link to="/login">Return to Home</router-link>
        </div>
      </q-card>
    </div>
  </div>
</template>

<script>
import Layout from "../components/Layout";
import axios from "../axios/";
export default {
  components: {
    Layout,
  },
  data() {
    return {
      message: null,
    };
  },
  async created() {
    try {
      const { data } = await axios.post(`forms/demo-account-request/${this.$route.params.id}`, {});
      this.message = data.message;
    } catch (error) {
      this.message = error.response.data.message;
    }
  },
};
</script>
